import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Alert, AlertDescription, AlertIcon, AlertTitle, Box } from '@abb/uikit';
import React from 'react';
import { withTranslation } from 'react-i18next';
class ErrorBoundary extends React.Component {
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    componentDidCatch(error) {
        console.log(error);
    }
    render() {
        const { hasError } = this.state;
        const { t, children } = this.props;
        if (hasError) {
            return /*#__PURE__*/ _jsxs(Alert, {
                status: "error",
                variant: "left-accent",
                mt: "48px",
                backgroundColor: "red.50",
                borderRadius: "6px",
                children: [
                    /*#__PURE__*/ _jsx(AlertIcon, {}),
                    /*#__PURE__*/ _jsxs(Box, {
                        flex: "1",
                        children: [
                            /*#__PURE__*/ _jsx(AlertTitle, {
                                children: t('account.attention')
                            }),
                            /*#__PURE__*/ _jsx(AlertDescription, {
                                display: "block",
                                children: t('errors.permissionError')
                            })
                        ]
                    })
                ]
            });
        } else {
            return /*#__PURE__*/ _jsx(_Fragment, {
                children: children
            });
        }
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}
export default withTranslation('common')(ErrorBoundary);
